/** @jsxImportSource theme-ui */
import RedirectDomains from '@/containers/redirectDomains/RedirectDomains';

const RedirectDomainsPage = () => <RedirectDomains />;

export default RedirectDomainsPage;
